/**
 * @file Client error message definitions mapping for GQL errors.
 */
import React from 'react';

const ERROR_MESSAGES = {
  E001: 'Invalid Join Code.',
  E005:
    'Please choose another headshot, where there’s only one, clearly visible face on it.',
  E006: 'Please upload a new headshot. And remember: Only one face per photo.',
  E007:
    'Something went wrong with my selfie validator. Please try a bit later or upload a different photo.',
  E010:
    'Sorry, it appears you do not have enough privileges to perform this action.',
  E029: 'That username has already been taken, please try a different one.',
  E058:
    'There was a problem with your selfie. Please provide a headshot without sunglasses.',
  E085: 'The email address provided has already been invited.',
  E086:
    'We couldn’t find your invitation. Please make sure you clicked the correct link!',
  E087: 'The invitation’s email does not match your account’s email.',
  E088: 'This invitation is already being used by another account!',
  E097:
    'Sorry, that PIN doesn’t match the phone number we expected. Please ensure you’ve entered the correct PIN that was sent to you.',
  E104:
    'Not enough photos to complete the configuration. Please select photos for all slots.',
  E103:
    'It looks like you’ve already configured your print and we have sent your order! Please contact our support at support@waldophotos.com if you think this happened by mistake. Apologies for the inconvenience!',
  E160: `That email address doesn't seem to be valid. Please ensure you've entered it correctly`,
  E161: `Your username can only contain letters, numbers and '_'`,
  E162: 'That email address has already been used for a signup reservation.',
  E176:
    'Whoops! The password you provided wasn’t a match. Please make sure you’ve entered the right one.',
  E183: 'Sorry, that username is not allowed.',
  E232:
    'The invited account already belongs to an organization using Waldo. Please invite using their personal email address or phone number.',
  E226:
    'Sorry, you must add an album to your gallery before adding a Memory Mate, Collage, or Self-fulfilled product for individual sale.',
  E337:
    'Please choose another headshot, where there’s only one, clearly visible face on it.',
};

export const FAILED_TO_FETCH_ERROR_MESSAGE = 'Network error: Failed to fetch';
export const FAILED_TO_FETCH_ERROR_REPLACEMENT = (
  <>
    If you’re having trouble accessing Waldo via WiFi, please email us the name
    of your internet provider and the make and model of your router to{' '}
    <a href="mailto:support@waldophotos.com" className="text-white text-bold">
      support@waldophotos.com.
    </a>
  </>
);

export default ERROR_MESSAGES;
